import axios from 'axios'

const ajax = {
  post: function (url, data) {
    return axios({
      url: url,
      method: 'post',
      data: data,
      transformRequest: [
        function (data) {
          let ret = '';
          for (let it in data) {
            ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
          }
          ret = ret.substring(0, ret.length - 1);
          return ret
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  get: function (url, data) {
    return axios({
      url: url,
      method: 'get',
      params: data,
      transformRequest: [
        function (data) {
          let ret = '';
          for (let it in data) {
            ret +=
                encodeURIComponent(it) +
                '=' +
                encodeURIComponent(data[it]) +
                '&'
          }
          ret = ret.substring(0, ret.length - 1);
          return ret
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
};
export default ajax



// WEBPACK FOOTER //
// ./src/common/js/common.js